import React from "react";
import { C } from "../../core/constants";
import GlassCard from "../../ui/GlassCard";
import { useI18n } from "../../features/i18n/LocaleProvider";

export default function PolicyPage({ title, updatedAt, sections, acc }) {
  const { t } = useI18n();
  return (
    <div style={{ position: "relative", zIndex: 1, paddingTop: 68 }}>
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "48px 28px 72px" }}>
        <GlassCard style={{ padding: "36px 32px" }} glow accent={acc.primary}>
          <div style={{ fontSize: 12, letterSpacing: "0.14em", color: acc.primary, textTransform: "uppercase", marginBottom: 10 }}>
            {t("legal")}
          </div>
          <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: "clamp(34px,4vw,52px)", fontWeight: 400, color: C.textPrimary, marginBottom: 8 }}>
            {title}
          </h1>
          <p style={{ fontSize: 13, color: C.textMuted, marginBottom: 24 }}>
            {t("last_updated")}: {updatedAt}
          </p>
          <div style={{ display: "grid", gap: 18 }}>
            {sections.map((section) => (
              <div key={section.heading}>
                <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 30, fontWeight: 400, color: C.textPrimary, marginBottom: 8 }}>
                  {section.heading}
                </h2>
                <p style={{ fontSize: 14, color: C.textSecondary, lineHeight: 1.8, whiteSpace: "pre-wrap" }}>{section.body}</p>
              </div>
            ))}
          </div>
        </GlassCard>
      </div>
    </div>
  );
}
